import { p as proxyCustomElement, H, h } from './p-ae815584.js';

const cosmosModeCss = ".cosmos-mode{display:contents}";
const CosmosModeStyle0 = cosmosModeCss;

const CosmosMode = /*@__PURE__*/ proxyCustomElement(class CosmosMode extends H {
    constructor() {
        super();
        this.__registerHost();
        this.mode = 'light';
    }
    render() {
        return (h("div", { key: '1fca0def780c6d82a973e4c9bf2564ae3a1d2e41', class: "cosmos-mode" }, h("slot", { key: '53294fd760064e22dcd0cef7e73a3b0d3fe297c6' })));
    }
    get element() { return this; }
    static get style() { return CosmosModeStyle0; }
}, [4, "cosmos-mode", {
        "mode": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-mode"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-mode":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosMode);
            }
            break;
    } });
}

export { CosmosMode as C, defineCustomElement as d };
